import clsx from 'clsx';
import React from 'react';

import { SubscribeSource } from '@utils/backend-api/userOnboarding';

import { OnboardingSteps, getStepNumber, getTotalStepsForSource, stepName } from './interface';

interface ProgressBarProps {
  step: OnboardingSteps;
  isProSubscriber?: boolean;
  subscribeSource?: SubscribeSource;
}

const ProgressBar = ({ step, isProSubscriber = false, subscribeSource }: ProgressBarProps) => {
  const totalSteps = getTotalStepsForSource(subscribeSource);
  const currentStepNumber = getStepNumber(step, subscribeSource);
  const progress = Math.min((currentStepNumber / totalSteps) * 100, 100);

  return (
    <div className="w-full">
      <div className="mb-2 flex items-center justify-between px-40 py-8 md:px-0 md:py-0">
        <span className="font-suisse-intl-mono text-overline-md font-light text-black md:text-white">
          {stepName[step]}
        </span>
        <span className="font-suisse-intl-mono text-overline-md font-light text-black md:text-white">
          {currentStepNumber}/{totalSteps}
        </span>
      </div>
      <div className="h-[10px] w-full overflow-hidden bg-gray-200">
        <div
          className={clsx('h-full transition-all duration-300 ease-in-out', {
            'bg-primary-magenta': !isProSubscriber,
            'bg-pro-gold': isProSubscriber,
          })}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
